import { green, grey, pastelGreen, red } from '@web/birdz-angular';
import { hasNumericValues, Kpi } from 'app/interfaces/kpi.interface';
import { KpiValue } from 'app/types/kpi-value.type';

export type KpiLegendItemId =
  'stateOk' | 'stateKo' | 'isCompliant' | 'isNotCompliant' | 'ratioAboveThreshold' | 'ratioUnderThreshold';

// marker color, and darker variant for texts
export const KPI_LEGEND_COLORS: Record<KpiLegendItemId, { color: string; textColor: string }> = {
  stateOk: { color: pastelGreen, textColor: green },
  stateKo: { color: red, textColor: red },
  isCompliant: { color: pastelGreen, textColor: green },
  isNotCompliant: { color: red, textColor: red },
  ratioAboveThreshold: { color: pastelGreen, textColor: green },
  ratioUnderThreshold: { color: red, textColor: red },
};

/**
 * Legend item a kpi value belongs to (null when the value cannot be classified)
 */
export function getKpiLegendItemId(kpi: Kpi, value: KpiValue | number | null): KpiLegendItemId | null {
  if (value === null) {
    return null;
  }

  if (!hasNumericValues(kpi)) {
    return value === 'OK' ? 'stateOk' : 'stateKo';
  }

  const number = value as number;
  if (kpi.type === 'NB_JOURS') {
    // a single penalty day is a non-compliance
    return number < 1 ? 'isCompliant' : 'isNotCompliant';
  }

  if (kpi.type === 'RATIO' && kpi.threshold !== null) {
    return number * 100 >= kpi.threshold ? 'ratioAboveThreshold' : 'ratioUnderThreshold';
  }

  return null;
}

export function getKpiColor(kpi: Kpi, value: KpiValue | number | null, isText = false): string {
  const legendItemId = getKpiLegendItemId(kpi, value);
  if (legendItemId === null) {
    return grey;
  }
  const colors = KPI_LEGEND_COLORS[legendItemId];
  return isText ? colors.textColor : colors.color;
}
